export default (item) => {
  if (!item.location) return false;
  const hasLocation = Object.keys(item).includes('location')
  && item.location.length === 2
  && (item.location[0] !== null && item.location[1] !== null);
  return hasLocation;
};
